import React, { useEffect, useState, useRef } from 'react'
import { fetchPage, prefetchPage, clearPages } from '../../features/pagination/pageCache'
import Floatingbutton from './Floatingbutton'
import Addusersmodal from '../SuperAdminmodal/Addusersmodal'
import Conformationdeleteusermodal from '../SuperAdminmodal/Conformationdeleteusermodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useMemo } from 'react'

const Allusersunitplan = () => {
  const [showModal, setShowModal] = useState(false)
  const [selectId, setSelectId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [users, setUsers] = useState([])
  // id of the newest page request; older responses are ignored so fast
  // clicks on the arrows never show a stale page
  const latestRequest = useRef(0)
  // fresh data on every visit: drop cached pages when leaving this screen
  useEffect(() => () => clearPages(`${config.apiUrl}/flat-details/getAll`), [])
  const [inputData, setInputData] = React.useState([])
  const [rolls, setRolls] = React.useState([])

  const [pagination, setPagination] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    limit: 0,
    hasNextPage: false,
    hasPrevPage: false
  })

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(() => {
    peginationdata()
  }, [pagination.currentPage, pagination.limit])

  useEffect(() => {
    fetchinputs()
  }, [])

  useEffect(() => {
    fetchrolls()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchrolls()
    }
  }, [showModal])

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchrolls = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/roles/list`, {
        headers: { Authorization: token }
      })

      console.log('ROLES ARRAY:', res.data.data)
      const normalized = (res.data.data || []).map(roll => ({
        rollId: roll.ID,
        rollName: roll.Name
      }))

      setRolls(normalized)
    } catch (err) {
      console.error(err)
      // toast.error('Failed to fetch posts')
    }
  }

  const pageUrl = (page, limit) => `${config.apiUrl}/flat-details/getAll?page=${page}&limit=${limit}`

  const peginationdata = async () => {
    const token = localStorage.getItem('token')
    const headers = { Authorization: token }
    const requestId = ++latestRequest.current
    try {
      const data = await fetchPage(pageUrl(pagination.currentPage, pagination.limit), headers)
      if (requestId !== latestRequest.current) return
      const res = { data }

      // pre-load the neighbouring pages so the next arrow click is instant
      const p = data.pagination
      if (p) {
        if (p.hasNextPage) prefetchPage(pageUrl(p.currentPage + 1, p.limit), headers)
        if (p.hasPrevPage) prefetchPage(pageUrl(p.currentPage - 1, p.limit), headers)
      }
       const usersData = res.data.data ?? []

  setUsers(
  usersData
    .map(item => ({
      id: item.ID,
      username: item.MembersName?.trim() || '',
      RoomNo: `${item.BldgNo || ''} / ${item.FlatNo || ''}`,
      CurrentAreaCASqft: item.CurrentAreaCASqft?.trim() || '',
      EligibleAreaCAPlus50PercentSqft: item.EligibleAreaCAPlus50PercentSqft?.trim() || '',
      NearestAreaAsPerPlanSqft: item.NearestAreaAsPerPlanSqft?.trim() || '',
      FlatSizeOptedAsPerScheme: item.FlatSizeOptedAsPerScheme?.trim() || 'NA',
      DifferenceInAreaSqft6Minus5: item.DifferenceInAreaSqft6Minus5?.trim() || 'NA',
      AdditionalAreaAsPerSchemeI7Minus5: item.AdditionalAreaAsPerSchemeI7Minus5?.trim() || 'NA',
      JodiFlat: item.JodiFlat?.trim()|| 'NA',
      ExtraFlatSchemeII: item.ExtraFlatSchemeII?.trim() || 'NA',
      deletedOn: item.DeletedOn 
    }))
    .sort((a, b) => b.id - a.id)
)
      

      setPagination(prev => ({
        ...prev,
        totalRecords: res.data.pagination?.totalRecords ?? 0,
        totalPages: res.data.pagination?.totalPages ?? 0,
        currentPage: res.data.pagination?.currentPage ?? prev.currentPage,
        limit: res.data.pagination?.limit ?? prev.limit,
        hasNextPage: res.data.pagination?.hasNextPage ?? false,
        hasPrevPage: res.data.pagination?.hasPrevPage ?? false
      }))
    } catch (err) {
      toast.error('Failed to load users')
    }
  }

 

  const handleConfirmDelete = async () => {
    if (!deleteId) return

    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/user/delete/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      clearPages(`${config.apiUrl}/flat-details/getAll`)
      await peginationdata()

      setUsers(prev => prev.filter(user => user.id !== deleteId))

      toast.success('User deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete user')
    }
  }

  // Move immediately; arrow state is derived from page numbers so several
  // quick clicks each advance a page without waiting for the server
  const goPrevious = () => {
    setPagination(prev => {
      if (prev.currentPage <= 1) return prev
      const currentPage = prev.currentPage - 1
      return { ...prev, currentPage, hasPrevPage: currentPage > 1, hasNextPage: currentPage < prev.totalPages }
    })
  }

  const goNext = () => {
    setPagination(prev => {
      if (prev.currentPage >= prev.totalPages) return prev
      const currentPage = prev.currentPage + 1
      return { ...prev, currentPage, hasPrevPage: currentPage > 1, hasNextPage: currentPage < prev.totalPages }
    })
  }

  const handleRowsPerPageChange = e => {
    setPagination(prev => ({
      ...prev,
      limit: parseInt(e.target.value),
      currentPage: 1
    }))
  }

  const startRow = (pagination.currentPage - 1) * pagination.limit + 1
  const endRow = Math.min(
    pagination.currentPage * pagination.limit,
    pagination.totalRecords
  )

  const projectMap = useMemo(() => {
    const map = {}
    inputData.forEach(item => {
      if (!map[item.projectId]) {
        map[item.projectId] = item.projectName
      }
    })
    return map
  })
  console.log(projectMap)

  const RollsName = useMemo(() => {
    const rollmap = {}
    rolls.forEach(item => {
      if (!rollmap[item.rollId]) {
        rollmap[item.rollId] = item.rollName
      }
    })
    return rollmap
  })
  console.log(RollsName)

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteModal = id => {
    setDeleteId(id)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  return (
    <div id="app-Capsule">
      <div className="pt-4">
        <h2 style={{paddingTop:'2rem', textAlign:'center'}}>All Users Unit Plan</h2>
        <div
  className="table-responsive-sm pt-5"
  style={{
    maxHeight: '100vh',
    overflowY: 'auto'
  }}
>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center text-bold fs-6">Sr.No</th>
                <th className="text-center text-bold fs-6">Name</th>
                <th className="text-center fs-6 text-bold">Bldg No./ FlatNo</th>
                <th className='text-center fs-6 text-bold'>CurrentAreaCASqft</th>
                <th className='text-center fs-6 text-bold'>EligibleAreaCAPlus50PercentSqft</th>
                <th className='text-center fs-6 text-bold'>NearestAreaAsPerPlanSqft</th>
                <th className='text-center fs-6 text-bold'>FlatSizeOptedAsPerScheme</th>
                <th className='text-center fs-6 text-bold'>DifferenceInAreaSqft6Minus5</th>
                <th className='text-center fs-6 text-bold'>AdditionalAreaAsPerSchemeI7Minus5</th>
                <th className='text-center fs-6 text-bold'>JodiFlat</th>
                <th className='text-center fs-6 text-bold'>ExtraFlatSchemeII</th>
                <th className="text-center fs-6 text-bold">Delete User</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id}
                  className="text-center"
                  style={{
                    cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                    // color: user.deletedOn ? 'red' : 'inherit',
                    background: user.deletedOn ? 'rgb(220 220 220)' : 'inherit'
                  }}
                >
                  <th scope="row">{startRow + index}</th>
                   <td className="text-bold">{user.username}</td>
                   <td className='text-bold'>{user.RoomNo}</td>

  <td className="text-bold">{user.CurrentAreaCASqft}</td>

  <td className="text-bold">{user.EligibleAreaCAPlus50PercentSqft}</td>

  <td className="text-bold">{user.NearestAreaAsPerPlanSqft}</td>

  <td className="text-bold">{user.FlatSizeOptedAsPerScheme}</td>

  <td className="text-bold">{user.DifferenceInAreaSqft6Minus5}</td>

  <td className="text-bold">{user.AdditionalAreaAsPerSchemeI7Minus5}</td>

  <td className="text-bold">{user.JodiFlat}</td>

  <td className="text-bold">{user.ExtraFlatSchemeII}</td>
                  
                  {/* <th>{projectMap[user.ProjectID] || '—'}</th> */}
                  {/* <th>{RollsName[user.roleId] || '—'}</th> */}
                  {/* <th>{user.Wing}</th> */}
                 
                  
                  <th>
                    <div
                      className="rounded-circle"
                      style={{
                        backgroundColor: 'red',
                        width: '30px',
                        height: '30px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: 'auto',
                        filter: user.deletedOn ? 'blur(2px)' : 'none',
                        opacity: user.deletedOn ? 0.5 : 1
                      }}
                      onClick={() => {
                        if (!user.deletedOn) {
                          handleDeleteModal(user.id)
                        }
                      }}
                    >
                      <ion-icon
                        name="trash"
                        style={{ fontSize: '15px', color: 'white' }}
                      />
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-center"style={{
        paddingBottom: "5rem",
        paddingTop: "1rem"
      }}>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goPrevious}
            disabled={!pagination.hasPrevPage}
          >
            &lt;
          </button>

          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goNext}
            disabled={!pagination.hasNextPage}
          >
            &gt;
          </button>

          <span className="fw-medium mx-2">
            Page <strong>{pagination.currentPage}</strong> of{' '}
            <strong>{pagination.totalPages}</strong>
          </span>

          <div className="d-flex align-items-center gap-2">
            <span>Show</span>
            <select
              className="form-select form-select-sm"
              value={pagination.limit}
              onChange={handleRowsPerPageChange}
              style={{ width: '80px' }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="30">30</option>
            </select>
          </div>
        </div>

        {/* <div className="text-muted small" style={{ paddingLeft: '12px' }}>
          Showing <strong>{startRow}</strong> to <strong>{endRow}</strong> of{' '}
          <strong>{pagination.totalRecords}</strong> Rows
        </div> */}
      </div>

      <Floatingbutton onOpen={() => setShowModal(true)} />
      <Addusersmodal
        show={showModal}
        userId={selectId}
        // createusers={createusers}
        fetchinputs={fetchinputs}
        inputData={inputData}
        rolls={rolls}
        onClose={() => setShowModal(false)}
      />
      <Conformationdeleteusermodal
        show={showConfirmModal}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  )
}

export default Allusersunitplan